var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H16V4H18V2ZM3.99988 4.00002H9.99988V6.00002H3.99988V20H17.9999V14H19.9999V22H19.9999V22H1.99988V22V20V6.00002V4.00002H3.99988ZM8.00006 12H6.00006V16V18V18H12.0001V16L13.9999 16V14H11.9999V16L8.00006 16V12ZM11.9999 10H10V11.9999H8V9.99994H9.99994V8.00002H11.9999V6.00002H13.9999V8.00002H11.9999V10ZM14.0001 4.00002H16.0001V6.00002H14.0001V4.00002ZM17.9999 4.00002H19.9999V6.00002H21.9999V8.00002H19.9999V10H18V11.9999H16V9.99994H17.9999V8.00002H19.9999V6.00002H17.9999V4.00002ZM14.0001 12H16.0001V14H14.0001V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditM);
export default __webpack_public_path__ + "static/media/edit-m.cd9102d7e595606650b9ff0e8715301f.svg";
export { ForwardRef as ReactComponent };